import React from "react";
import FormLayout from "../NewFormBuilder";

const InterfaceView: React.FC = () => {
  return <FormLayout />;
};

export default InterfaceView;
